import { createElement, useCallback, useState } from 'react';
import FeedbackToast, { FeedbackKind } from '../components/FeedbackToast/FeedbackToast';

type FeedbackState = { message: string; kind: FeedbackKind } | null;

export function useFeedback() {
  const [feedback, setFeedback] = useState<FeedbackState>(null);

  const clear = useCallback(() => setFeedback(null), []);

  const showError = useCallback((message: string) => {
    setFeedback({ message, kind: 'error' });
  }, []);

  const showSuccess = useCallback((message: string) => {
    setFeedback({ message, kind: 'success' });
  }, []);

  const feedbackNode = feedback
    ? createElement(FeedbackToast, {
        message: feedback.message,
        kind: feedback.kind,
        onClose: clear,
      })
    : null;

  return { feedback, showError, showSuccess, clear, feedbackNode };
}
